import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=dcee121a&scoped=true&"
import script from "./TagInput.vue?vue&type=script&lang=ts&"
export * from "./TagInput.vue?vue&type=script&lang=ts&"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=dcee121a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcee121a",
  null
  
)

export default component.exports